import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { DashboardTaskWording, DashboardTasksComponent } from '../dashboard-tasks/dashboard-tasks.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-dashboard-task',
    templateUrl: './modal-dashboard-task.component.html',
    styleUrls: ['./modal-dashboard-task.component.scss'],
    imports: [DashboardTasksComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalDashboardTaskComponent implements OnInit {
    data = inject<{
    action?: string;
    target?: string;
    title?: string;
    wording?: DashboardTaskWording;
    canCreateTasks?: boolean;
}>(MAT_DIALOG_DATA);
    private dialogRef = inject<MatDialogRef<ModalDashboardTaskComponent>>(MatDialogRef);

    taskCreated = false;

    constructor() {
        const dialogRef = this.dialogRef;

        dialogRef.backdropClick().subscribe(v => {
            dialogRef.close(this.taskCreated);
        });
    }

    ngOnInit(): void {
    }

}
